import BaseComponent from '../../js/base-component';

export default class CommentComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.form = this.refs.form;
        this.textarea = this.refs.textarea;
        this.feature = this.refs.feature;
        this.accordion = this.refs.accordion;
        this.editComment = document.getElementById('edit-comment');
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onEditCommentClick = this.onEditCommentClick.bind(this);
    }

    static getRequiredRefs(){
        return [ 'form', 'textarea', 'feature', 'accordion'];
    }

    init(){
        this.form.addEventListener('submit', this.onFormSubmit);

        if(this.editComment){
            this.editComment.addEventListener('click', this.onEditCommentClick);
        }
    }

    onEditCommentClick() {
        this.textarea.value = this.editComment.parentNode.nextSibling.textContent;
        this.form.classList.remove('visually-hidden');
        this.accordion.classList.remove('is-collapsed');
        this.accordion.classList.add('is-expanded');

        setTimeout(() => {
            this.element.scrollIntoView({
                block: "start",
                behavior: "smooth"
            });
        }, 10);
        return false;
    }

    onFormSubmit(e){
        this.feature.value = '1';
        let date = new Date(new Date().getTime() + 2592000 * 1000);
        document.cookie = "Bounty=3; path=/; expires=" + date.toUTCString();
    }

    onDestroy(){
        this.form.removeEventListener('submit', this.onFormSubmit);
        if(this.editComment){
            this.editComment.removeEventListener('click', this.onEditCommentClick);
        }
    }
}
